import {Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {Character} from 'gamesis-story-client';
import {Store} from '@ngrx/store';
import {selectCharacterById} from 'gamesis-state';

@Directive({
    selector: '[characterAvatar]',
    standalone: false
})
export class CharacterAvatarComponent {
    private initialsEL: HTMLSpanElement | null = null;

    @Input()
    public set characterAvatar(character: string | Character) {
        if (typeof character === 'string') {
            this.store.select(selectCharacterById(character as string))
                .subscribe((char) => {
                    this.setAvatar(char);
                });
        } else {
            this.setAvatar(character as Character);
        }
    }

    constructor(private el: ElementRef,
                private renderer: Renderer2,
                private store: Store) {
    }

    setAvatar(character?: Character) {
        if (!character) {
            return;
        }

        // Clear previous initials if any
        if (this.initialsEL) {
            this.renderer.removeChild(this.el.nativeElement, this.initialsEL);
            this.initialsEL = null;
        }

        if (character.avatar) {
            // Set avatar as background
            this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(data:image/png;base64,${character.avatar})`);
            this.renderer.setStyle(this.el.nativeElement, 'background-size', 'cover');
            this.renderer.setStyle(this.el.nativeElement, 'background-position', 'center');
            this.renderer.setStyle(this.el.nativeElement, 'background-repeat', 'no-repeat');
        } else {
            // No avatar? Show initials instead
            this.renderer.setStyle(this.el.nativeElement, 'background-image', 'none');
            this.renderer.setStyle(this.el.nativeElement, 'display', 'flex');
            this.renderer.setStyle(this.el.nativeElement, 'align-items', 'center');
            this.renderer.setStyle(this.el.nativeElement, 'justify-content', 'center');
            this.renderer.setStyle(this.el.nativeElement, 'font-size', '20px');

            // Create initials element
            this.initialsEL = this.renderer.createElement('span');
            this.initialsEL.classList.add('shout');
            this.renderer.addClass(this.el.nativeElement, 'bg-dark');
            const text = this.renderer.createText(character.initials);
            this.renderer.appendChild(this.initialsEL, text);
            this.renderer.appendChild(this.el.nativeElement, this.initialsEL);
        }
    }
}
